// extracted by mini-css-extract-plugin
module.exports = {"composeDecoration":"ComposeDecoration__composeDecoration__wS3Zz","suggest":"ComposeDecoration__suggest__IvcGb","suggestChild":"ComposeDecoration__suggestChild__lyAJm"};